import {
  userLoginOut, getGroupInfo, getGroupByParent, editRootGroup, deleteRootGroup, editGroup, getGroupPersAndPark, editUser,
  deleteUser, getUserByGroupId, getPerAndParkByParent, getCurrentUserPerAndParkByGroup, getCurrentUser, editCurrentUserPwd, getAllPers,
  getCurrentUserPers, resetUserPwd, getCurrentUserStatisticalData
} from '../../api/user'
const state = {
  groupInfoData: {},
  curUserPerAndParks: {},
  navNodeList: [],
  userGroup: []
}
// mutations
const mutations = {
  setState (state, groupInfo) {
    state.groupInfoData = groupInfo
  },
  setNodeList (state, data) {
    state.navNodeList = data
  },
  setCurUserPerAndParks (state, perWithParks) {
    state.curUserPerAndParks = perWithParks
  },
  setUserGroup (state, data) {
    state.userGroup = data
  }
}
// const utils = {
//   appendNode (pNode, node) {
//     if (pNode.id === node.parentId) {
//       if ((pNode.children || []).length > 0) {
//         pNode.children.push(node)
//       } else {
//         pNode.children = []
//         pNode.children.push(node)
//       }
//     } else {
//       for (let i = 0; i < (pNode.children || []).length; i++) {
//         this.appendNode(pNode.children[i], node)
//       }
//     }
//   },
//   updateNode (pNode, node) {
//     if (pNode.id === node.id) {
//       pNode.name = node.name
//     } else {
//       for (let i = 0; i < (pNode.children || []).length; i++) {
//         this.updateNode(pNode.children[i], node)
//       }
//     }
//   },
//   removeNode (pNode, node) {
//     if (pNode.id === node.parentId) {
//       if ((pNode.children || []).length > 0) {
//         pNode.children.splice(pNode.children.indexOf(node), 1)
//       }
//     } else {
//       for (let i = 0; i < (pNode.children || []).length; i++) {
//         this.removeNode(pNode.children[i], node)
//       }
//     }
//   }

// }
// actios
const actions = {
  logOut ({ commit }) {
    return new Promise((resolve, reject) => {
      userLoginOut().then(response => {
        localStorage.removeItem('fUserNo')
        localStorage.removeItem('fGroupName')
        localStorage.removeItem('fUsrID')
        localStorage.removeItem('rember')
        localStorage.removeItem('panelUrl')
        localStorage.removeItem('svrPanelUrl')
        localStorage.removeItem('svrPanelUsrNo')
        localStorage.removeItem('fUsrName')
        localStorage.removeItem('token')
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  groupInfo ({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      let paramJson = {}
      paramJson['fUsrNo'] = localStorage.getItem('fUserNo')
      getGroupInfo(paramJson).then(response => {
        if (response && response.data) {
          let { data } = response
          commit('setState', data.Data)
        }
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  setNode ({ commit }, param) {
    commit('setNodeList', param || [])
  },
  setUserGroup ({ commit }, param) {
    commit('setUserGroup', param || [])
  },
  getGroupByParent ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getGroupByParent(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  editRootGroup ({ commit }, info) {
    return new Promise((resolve, reject) => {
      editRootGroup(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  editGroup ({ commit }, info) {
    return new Promise((resolve, reject) => {
      editGroup(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  deleteRootGroup ({ commit }, info) {
    return new Promise((resolve, reject) => {
      deleteRootGroup(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getGroupPersAndPark ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getGroupPersAndPark(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  editUser ({ commit }, info) {
    return new Promise((resolve, reject) => {
      editUser(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getCurrentUser ({ commit }, info) {
    return new Promise((resolve, reject) => {
      getCurrentUser(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  editCurrentUserPwd ({ commit }, info) {
    return new Promise((resolve, reject) => {
      editCurrentUserPwd(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getUserByGroupId ({ commit }, info) {
    return new Promise((resolve, reject) => {
      getUserByGroupId(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  deleteUser ({ commit }, info) {
    return new Promise((resolve, reject) => {
      deleteUser(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getPerAndParkByParent ({ commit }, info) {
    return new Promise((resolve, reject) => {
      getPerAndParkByParent(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getCurrentUserPerAndParkByGroup ({ commit }) {
    return new Promise((resolve, reject) => {
      getCurrentUserPerAndParkByGroup().then(response => {
        let { data } = response
        commit('setCurUserPerAndParks', data.Data)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getAllPers ({ commit }, info) {
    return new Promise((resolve, reject) => {
      getAllPers(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getCurrentUserPers ({ commit }, info) {
    return new Promise((resolve, reject) => {
      getCurrentUserPers(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  resetUserPwd ({ commit }, info) {
    return new Promise((resolve, reject) => {
      resetUserPwd(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getCurrentUserStatisticalData ({ commit }, info) {
    return new Promise((resolve, reject) => {
      getCurrentUserStatisticalData(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/user.js